<mat-card
  [class.card-shadow]="applyShadow"
  [class.flex-100]="fullWidth"
  [class.card-overflow]="overflow"
  [ngClass]="cardClass"
  [ngStyle]="cardStyle"
  [attr.data-theme-scope]="themeScope || null"
  (click)="cardClick.emit($event)">
  <ng-content></ng-content>
</mat-card>
